import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/Hooks";
import { RootState } from "../../../store/Store";
import { ReportListEffect } from "./effect";
import { ConfigReport } from "../../../utils/types/ConfigReport";
import { useNavigate } from "react-router";

export function useHook() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [available, setAvailable] = useState()

  const { user } = useAppSelector((state: RootState) => state.loginuser);
  const { configReports, configReportsSelected } = useAppSelector(
    (state: RootState) => state.reportList
  );

  function handleClick(configReport: ConfigReport) {
    if (
      configReportsSelected.value?.find(
        (configReportSelected) => configReportSelected.id === configReport.id
      ) === undefined
    ) {
      return;
    }

    navigate(`./${configReport.reportId}`);
  }

  useEffect(() => {
    dispatch(ReportListEffect.clean());
    dispatch(ReportListEffect.getConfigReports());
    dispatch(ReportListEffect.getConfigReportsSelected(user.rol!));

    return () => {
      dispatch(ReportListEffect.clean());
    };
  }, []);

  useEffect(() => {
  }, [configReports, configReportsSelected]);

  return {
    configReports,
    configReportsSelected,
    handleClick,
  };
}
